
import React from 'react'
import './responsedisplay.css'
import { Delete, Check, Cancel} from "@mui/icons-material"
import StatusContext from '../../../contexts/StatusContext'
import RefreshIcon from '@mui/icons-material/Refresh';
import MarkdownResponseDisplay from '../markdown/MarkdownResponseDisplay';
import {ScrollTextPrompt} from "../scrolltext/ScrollTextPrompt"
import { CopyTextIcon } from '../customicons/CopyTextIcon';
import { ButtonAIProvider } from '../buttonaiprovider/ButtonAIProvider';


export const ResponseDisplay = ({ displayprompt, displayicons, changeConfirmDelete, onDeletePrompt, onResubmitQuestion, onCopy, showprompts, showRefresh, width, displayprovidername,
                                  
 }) => {
  let {
    isMe, 
    isMobile,
    isLoading,
} = React.useContext(StatusContext); 
  
  return (
    <div disabled={isLoading} >
      {
        <div className="scrollTextQuestion"  style={{ width: isMobile() ? '100%' : (width === 0) ? '60%' : '100%' }} key={displayprompt.id}>
          {
            showprompts &&  
            <div >
              <div className='flex-container'>
              {
               
                (displayicons) ? (
              
                  <>
                   <Check className="promptIconColored"  onClick={() => { !isLoading && onDeletePrompt(displayprompt)}} />
                   <Cancel className="promptIconColored"  onClick={() => { !isLoading && changeConfirmDelete(displayprompt, false) }} />
                  </>
                )
                  : 
                (
                  <>
                  {
                  showRefresh && <RefreshIcon className="promptIconColored"  onClick={() => { !isLoading && onResubmitQuestion(displayprompt) }} />
                  }
                  <Delete className="promptIconColored"  onClick={() => { !isLoading && changeConfirmDelete(displayprompt, true) }} />
                  </>
                )
              }

              </div>
              
              {<ScrollTextPrompt text={displayprompt.prompt}/>}
         
            </div>
            
          }
        </div>
        
      }

      <div className='scrollTextResponse' style={{marginTop:'-15px'}}>
        <div className='flex-container'>
          <CopyTextIcon prompt={displayprompt} />
          {
            isMe() &&
            (displayprovidername && displayprompt.aiprovider) &&
              <ButtonAIProvider provider={displayprompt.aiprovider} model={displayprompt.ainame}/>
          }
        </div>

        <MarkdownResponseDisplay text={displayprompt.response} />  
      </div>

    </div>
  )
}


ResponseDisplay.defaultProps = {
  showprompts: true,
  showRefresh: true,
  width: 0,
  displayprovidername: true,
 
};

export default ResponseDisplay
